// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header--2209","mainArea":"Header-module__mainArea--134b","title":"Header-module__title--c924"};